
/**
 * 트윗 태그 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfTags = {
  hashtags?: string[];
};
